import { pageHead } from "@app/framework/meta";
import { ContactIrPage } from "@modules/investor-relations/pages";
import { trans } from "@mongez/localization";
import { MetaFunction } from "@remix-run/node";
import { useLoaderData } from "@remix-run/react";

export default function ContactIr() {
  useLoaderData();

  return <ContactIrPage />;
}

export const meta: MetaFunction = () =>
  pageHead({
    title: trans("contactIr"),
    appendAppName: true,
  });
